import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { Row, Col, Select, Button } from 'antd';
import { ConsultaStore } from '../../stores/consultaStore';
import { inject, observer } from 'mobx-react';
import { Months } from '../../models';
import { UserStore } from '../../stores';

const ConsultasWrapper = styled.div`
    margin: 0 auto;
    padding: 0 150px;
    max-width: 1600px;
`;

const PageHeader = styled.h1`
    margin-top: 25px;
    font-size: 24px;
`;

const ColStyled = styled(Col)`
    text-align: center;
`;

interface AnualInnerProps extends RouteComponentProps {
    consultaStore?: ConsultaStore;
    userStore?: UserStore;
}

@inject('consultaStore')
@inject('userStore')
@observer
class AnualInner extends React.Component<AnualInnerProps, {}> {
    async componentDidMount() {
        const { consultaStore, userStore } = this.props;
        consultaStore!.getMunicipios();
        if (userStore!.rol == 'ROL-RM' || userStore!.rol == 'ROL-ROO') {
            consultaStore!.filtrosReporteAnual!.Municipio = userStore!.municipio[0]!.id;
            consultaStore!.filtrosReporteAnual!.soapap =
                userStore!.tipoUsuario == 'OO-SOAPAP' ? true : false;
            if (userStore!.tipoUsuario == 'OO-SOAPAP') {
                consultaStore!.getMunicipiosSoapap();
            }
        } else {
            consultaStore!.getMunicipiosSoapap();
        }
    }

    renderTipoMunicipio = () => {
        return (
            <Select
                style={{ width: '100%', height: '35px', marginBottom: '18px' }}
                placeholder="Todos"
                onChange={this.changeTipoMunicipio}
            >
                <Select.Option key={0}>Seleccione</Select.Option>
                <Select.Option key={1}>Municipio</Select.Option>
                <Select.Option key={2}>SOAPAP</Select.Option>
            </Select>
        );
    };
    changeTipoMunicipio = async (value: any) => {
        const { consultaStore } = this.props;
        if (value == 2) {
            consultaStore!.filtrosReporteAnual!.soapap = true;
        } else {
            consultaStore!.filtrosReporteAnual!.soapap = false;
        }
    };

    renderMunicipios = () => {
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Todos"
                optionFilterProp="children"
                onChange={this.changeMunicipios}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaMunicipios.map(municipio => (
                    <Select.Option key={municipio.id}>{municipio.nombre}</Select.Option>
                ))}
            </Select>
        );
    };
    changeMunicipios = async (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtrosReporteAnual!.Municipio = value;
    };

    renderMunicipiosSoapap = () => {
        return (
            <Select
                showSearch={true}
                style={{ width: '100%' }}
                placeholder="Todos"
                optionFilterProp="children"
                onChange={this.changeMunicipios}
            >
                <Select.Option key={'0'}>Todos</Select.Option>
                {this.props.consultaStore!.listaMunicipiosSoapap.map(municipio => (
                    <Select.Option key={municipio.id}>{municipio.nombre}</Select.Option>
                ))}
            </Select>
        );
    };
    changeMunicipiosSoapap = async (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtrosReporteAnual!.Municipio = value;
    };

    renderEjercicio = () => {
        const { consultaStore } = this.props;
        const fecha = new Date();
        let arreEjercicio = [];
        for (var i = fecha.getFullYear(); i >= fecha.getFullYear() - 5; i--) {
            arreEjercicio.push(i);
        }
        return (
            <Select
                style={{ width: '100%' }}
                placeholder="Ejercicio"
                optionFilterProp="children"
                onChange={this.changeEjercicio}
                defaultValue='0'
            >
                <Select.Option key='0'>Seleccione</Select.Option>
                {arreEjercicio.map((value, index) => (
                    <Select.Option key={value}>{value}</Select.Option>
                ))}
            </Select>
        );
    };
    changeEjercicio = async (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtrosReporteAnual!.Ejercicio = value;
    };

    renderTipo = () => {
        const { consultaStore, userStore } = this.props;
        return (
            <Select style={{ width: '100%' }} placeholder="Todos" onChange={this.changeImpuesto}>
                <Select.Option key={'0'}>Todos</Select.Option>
                {userStore!.rol === 'ROL-ROO' ? null : consultaStore!.filtrosReporteAnual!
                      .soapap ? null : (
                    <Select.Option key={'2'}>Predial</Select.Option>
                )}
                <Select.Option key={'1'}>Agua</Select.Option>
            </Select>
        );
    };
    changeImpuesto = async (value: any) => {
        const { consultaStore } = this.props;
        consultaStore!.filtrosReporteAnual!.Tipo = value;
    };

    clickdescargar = async () => {
        const { consultaStore } = this.props;
        const response = await consultaStore!.getReporteAnual();
        if (!response) {
            return;
        }
        const type = 'application/pdf';
        const blob = new Blob([response!.data], { type });

        const fileDownload = require('react-file-download');
        const nombreArchivo = this.generarNombreAnual();
        fileDownload(blob, nombreArchivo + '.pdf');
    };

    generarNombreAnual = () => {
        const { consultaStore } = this.props;
        const fecha = new Date();
        let fechaString = fecha.getDate() < 10 ? '0' + fecha.getDate() : fecha.getDate().toString();
        fechaString += Months[fecha.getMonth()].substring(0, 3);
        fechaString += fecha.getFullYear();
        let nombre = '';
        const tipo = consultaStore!.filtrosReporteAnual!.Tipo == 2 ? 'Predial' : 'Agua';
        const municipio = consultaStore!.listaMunicipios.filter(
            m => m.id == consultaStore!.filtrosReporteAnual!.Municipio
        )[0].nombre;
        nombre =
            municipio +
            ' Anual ' +
            tipo +
            ' ' +
            consultaStore!.filtrosReporteAnual!.Ejercicio +
            ' ' +
            fechaString;
        return nombre;
    };

    render() {
        const stylePrimary = {
            backgroundColor: '#a8123e',
            borderColor: '#a8123e'
        };
        const styleVeda = {
            backgroundColor: '#3c3c3b',
            borderColor: '#3c3c3b'
        };
        const { consultaStore, userStore } = this.props;
        return (
            <>
                <ConsultasWrapper>
                    <Row style={{ textAlign: 'center' }}>
                        <PageHeader>Reportes Anuales</PageHeader>
                    </Row>
                    <Row style={{ paddingTop: '20px' }}>
                        {userStore!.rol != 'ROL-ROO' && userStore!.rol != 'ROL-RM' ? (
                            <>
                                <ColStyled span={6}>
                                    <strong>Municipios/SOAPAP</strong>
                                    {this.renderTipoMunicipio()}
                                </ColStyled>
                                <ColStyled span={6}>
                                    <strong>Municipio</strong>
                                    {consultaStore!.filtrosReporteAnual!.soapap
                                        ? this.renderMunicipiosSoapap()
                                        : this.renderMunicipios()}
                                </ColStyled>
                            </>
                        ) : userStore!.tipoUsuario == 'OO-SOAPAP' ? (
                            <ColStyled span={6}>
                                <strong>Municipio</strong>
                                {this.renderMunicipiosSoapap()}
                            </ColStyled>
                        ) : null}

                        <ColStyled span={6}>
                            <strong>Ejercicio</strong>
                            {this.renderEjercicio()}
                        </ColStyled>
                        <ColStyled span={6}>
                            <strong>Impuesto o Servicio</strong>
                            {this.renderTipo()}
                        </ColStyled>
                    </Row>
                    <Row style={{ textAlign: 'right' }}>
                        <Button
                            icon="download"
                            type="primary"
                            onClick={this.clickdescargar}
                            style={stylePrimary}
                        >
                            Descargar
                        </Button>
                    </Row>
                </ConsultasWrapper>
            </>
        );
    }
}
export const Anual = withRouter(AnualInner);
